import classNames from 'classnames';
import { forwardRef, useEffect, useRef } from 'react';
import { useTypograf } from '@/shared/hooks/use-typograf';
import { wrap } from '@/shared/lib/utils/dom';
import { mergeRefs } from '@/shared/lib/utils/merge-refs';
import Typografed from '../../shared/Typografed';

type Props = React.HTMLAttributes<HTMLElement> & {
    properties: {
        text: string;
        title?: string;
        listStyle: string;
    };
};

const ConstructorText = forwardRef<HTMLDivElement, Props>(
    ({ properties: { text, title, listStyle }, ...props }, ref) => {
        const el = useRef<HTMLDivElement>(null);
        const tpText = useTypograf(text || '');

        useEffect(() => {
            if (el.current) {
                Array.from(el.current.querySelectorAll('table')).forEach((el) => {
                    if (!el.closest('.table-container')) {
                        const wrapperEl = document.createElement('div');
                        wrapperEl.className = 'table-container';
                        wrap(el, wrapperEl);

                        if (!wrapperEl.closest('.table-wrapper')) {
                            const outerWrapperEl = document.createElement('div');
                            outerWrapperEl.className = 'table-wrapper';
                            wrap(wrapperEl, outerWrapperEl);
                        }
                    }
                });
            }
        }, []);

        return (
            <div
                {...props}
                ref={mergeRefs([ref, el])}
                className={classNames('constructor-block constructor-text news-detail-wrapper', props.className)}
            >
                {title && (
                    <div className="constructor-text-title">
                        <Typografed>{title}</Typografed>
                    </div>
                )}
                <div
                    className={classNames('text-s constructor-text__content wysiwyg', {
                        'number-li': listStyle === 'number',
                    })}
                    dangerouslySetInnerHTML={{ __html: tpText }}
                ></div>
            </div>
        );
    },
);

ConstructorText.displayName = 'ConstructorText';

export default ConstructorText;
